import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem("brushup_admin_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("brushup_admin_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export function loadAdminToken() {
  const t = localStorage.getItem("brushup_admin_token");
  if (t) api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
  return t;
}

loadAdminToken();
